import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/planicon.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import { data } from "react-router";
import noimage from '../images/noimage.jpeg';
import loadIcon from '../images/loader2.webp';
const Plans=()=>
{
    const [show,setShow]=useState(false);
    const [progress,setProgress]=useState(false);
    const [showResource,setShowResource]=useState(false);
    const [msg,setMsg]=useState("");
    const [plandata,setPlandata]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({planid:"",facilityid:"",planname:"",description:"",amount:"",resourcesid:[]});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);    
    const [resources,setResources]=useState([]);    
    const [selectedresources,setSelectedResources]=useState([]);    
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Facility", key: "facility", sortable: true},
        { name: "Plan", key: "planname", sortable: true },        
        { name: "Amount", key: "amount", sortable: true },
        { name: "Resources", key: "resources", sortable: true },                                
    ];
    function addPlan(event)
    {
        setFormData({planid:"",facilityid:"",planname:"",description:"",amount:"",resourcesid:[]});
        setShow(true);
        setMsg("");
    }
    async function saveData(event)
    {
        setMsg("");
        if(formData.facilityid=="" || formData.facilityid=="0")
        {
            setMsg("Select Facility!!!");
            return;
        }
        else if(formData.planname=="")
        {
            setMsg("Plan Name is Missing!!!");
            return;
        }
        else if(selectedresources.length==0)
        {
            setMsg("Select Resources!!!");
            return;
        }
        else if(formData.amount=="")
        {
            setMsg("Plan Amount is Missing!!!");
            return;
        }
        else if(window.confirm('Are you sure?'))    
        {
            
            //console.log(JSON.stringify(formData));
            setProgress(true);
            let url="/api/plan/SavePlan";            
            if(formData.planid!="") url="/api/plan/UpdatePlan/"+formData.planid;
            await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        alert("Data Saved Successfully");
                        setFormData({planid:"",facilityid:"",planname:"",description:"",amount:"",resourcesid:[]});
                        setShow(false);                        
                        loadPlans();
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                }); 
            setProgress(false);  
        }
    }
    async function loadPlans()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/plan/GetAllPlans").then(res=>
        {
            if(res.status==200)
            {
                setPlandata(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));                
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });        
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);                
            }
        }); 
        setProgress(false);
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=plandata.filter((e)=>e.facility.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.planname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.resources.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(plandata);                
                setPageData(plandata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=plandata.filter((e)=>e.facility==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...plandata]);
                setPageData(plandata.slice(0,pageSize));
            }
            setPage(1);
        }           
    }    
    async function formValueChanged(event)
    {
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});
        if(event.target.id=="facilityid")
        {           
            setFormData({...formData,facilityid:event.target.value});
            await apiClient.get(process.env.REACT_APP_APIURL+"/api/Resource/GetAllFacilityResources/"+event.target.value).then(reply=>
            {
                if(reply.status==200)
                {
                    if(reply.data.status=="OK")
                    {
                        setResources(reply.data.data);
                    }
                }
            });
            setSelectedResources([]);
        }
        if(event.target.id=="amount") setFormData({...formData,amount:event.target.value});
        if(event.target.id=="planname") setFormData({...formData,planname:event.target.value});
        if(event.target.id=="description") setFormData({...formData,description:event.target.value});        
    }        
    async function deletePlan(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
           setProgress(true);
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/Plan/DeletePlan/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadPlans();                    
                }
            });
            setProgress(false);
        }
    }        
    
    function sortData(colname)
    {
        let arr=[...dataToDisplay];
        if(colname=="facility" || colname=="planname" || colname=="resources" )
        {
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;            
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
        }
        else
        {
            arr.sort((e1,e2)=>
            {
                let x=parseFloat(e1[colname])>parseFloat(e2[colname])?1:-1;            
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );
        }
        setDataToDisplay(arr);                        
        setPageData(arr.slice(0,pageSize));
        setPage(1);                
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }   
    function addSelectedResource(event)
    {
        if(event.target.checked)
        {        
            let id=event.target.value;
            let idx=-1;
            resources.map((e,i)=>
            {
                if(e.resourceid==id) idx=i;
            });
            let idx1=-1;
            selectedresources.map((e,i)=>
            {
                if(e.resourceid==id) idx1=i;
            });
            if(idx1==-1)
            {
                setSelectedResources([...selectedresources,resources[idx]]);
                setFormData({...formData,resourcesid:[...formData.resourcesid,resources[idx].resourceid]});
            }
        }
    }
    function removeSelectedResource(id)
    {
            let idx=-1;
            selectedresources.map((e,i)=>
            {
                if(e.resourceid==id) idx=i;
            });
            if(idx>=0)
            {
                let arr=[...selectedresources];
                arr.splice(idx,1);
                setSelectedResources([...arr]);

                let arr1=[...formData.resourcesid];
                if(arr1.indexOf(id)>=0)
                {
                    arr1.splice(arr1.indexOf(id),1);
                    setFormData({...formData,resourcesid:[...arr1]});
                }
            }
    }
    useEffect(()=>{
        loadPlans();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">
                    <select className="form-control" id="searchFacility" onChange={searchData} style={{fontSize:'12px'}}>
                        <option>Facility</option>
                        {facilities.map((e, idx) => <option key={e.facilityid} value={e.facilityid}>{e.facilityname}</option>)}
                    </select>
                </div>                
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addPlan} /></div>
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Plans</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={`fac-${i}`} >{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}                                                       
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={`fac-${i}`}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    <td>{(ee.key=="photo1" || ee.key=="photo2" || ee.key=="photo3")?(<img src={e[ee.key]==""?noimage:e[ee.key]} width="30px" alt="" />):e[ee.key]}</td>                            
                                )}                                                                
                                <td className="text-center"><img onClick={()=>deletePlan(e.planid)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="2"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="2" className="text-center"></th>
                            <th colSpan="2" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="6">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>               
               {show && (                    
                    <div className="modal show d-block shadow" style={{zIndex:1050}}  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Plan</div>                                    
                                        <input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/>
                                        <select className="form-control" id="facilityid" onChange={formValueChanged}>
                                            <option value="0">Select Facility</option>                                            
                                            {facilities.map((e, idx) => <option key={e.id} value={e.id}>{e.facilityname}</option>)}
                                        </select>
                                        <input type="text" id="planname" onChange={formValueChanged} value={formData.planname} className="form-control mt-2" placeholder="Name of the Plan" />                                    
                                        <input type="number" id="amount" onChange={formValueChanged} value={formData.amount} className="form-control mt-2" placeholder="Plan Amount" />
                                        <textarea id="description" onChange={formValueChanged} className="form-control mt-2" placeholder="Plan Description/Details" >{formData.description}</textarea>
                                        <input type="button" onClick={()=>{if(!(formData.facilityid=="" ||formData.facilityid==0)) setSelectedResources([]);  setShowResource(true); }} value=" + Add Resources" className="btn btn-primary mt-2" /><br/>
                                        <div className="border shadow rounded p-2 mt-2">
                                            <div><b><u>Resource Details</u> &darr;</b></div>
                                            <div style={{maxHeight:'200px',height:'200px',overflow:"auto"}}>
                                                <table className="table table-bordered" style={{fontSize:'12px'}}>
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Abbr</th>
                                                            <th>Type</th>
                                                            <th>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {selectedresources.map((e,i)=>
                                                            <tr key={e.resourceid}>
                                                                <td>{i+1}</td>
                                                                <td>{e.abbr}</td>
                                                                <td>{e.rtype}</td>
                                                                <th><div onClick={()=>{removeSelectedResource(e.resourceid)}} style={{cursor:'pointer'}} className="text-danger">Remove</div></th>
                                                            </tr>
                                                        )}
                                                    </tbody>                                                
                                                </table>
                                            </div>
                                        </div>
                                        <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>                                    
                )}                
                {showResource && (
                <div
                    className="modal show d-block modal-backdrop-custom"
                    tabIndex="-1"
                    style={{ zIndex: 10000 }}   // 🔥 higher than parent
                    >
                    <div className="modal-dialog modal-dialog-centered modal-lg" style={{height: "70vh", maxHeight:'80vh'}}>
                    <div
                        className="modal-content rounded shadow" style={{border: "2px solid #000",background: "#fff",height:'100%',display:'flex',flexDirection:'column'}}>
                        <div className="modal-body p-3" style={{overflowY: "auto",flex: "1 1 auto"}}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0">Select Resources</h6>
                                <button
                                className="btn btn-close"
                                onClick={() => setShowResource(false)}
                                ></button>
                            </div>
                            <div>
                                <table className="table table-bordered table-striped" style={{fontSize:'12px'}}>
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Select</th>
                                            <th>Resource Abbr</th>
                                            <th>Name</th>
                                            <th>Type</th>                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resources.map((e,i)=>
                                            <tr key={e.resourceid}>
                                                <td>{i+1}</td>
                                                <td><input type="checkbox" value={e.resourceid} onChange={addSelectedResource} /></td>
                                                <td>{e.abbr}</td>
                                                <td>{e.name}</td>
                                                <td>{e.rtype}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>                        
                            <button className="btn btn-success w-25" onClick={() => setShowResource(false)}>
                                Add Resources
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                )}

                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Plans;